/**
 * @generated SignedSource<<6831b7421afbbc08b2db0d866cd8b894>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type usePermissionQuery$variables = {
  locator?: string | null;
  skip?: boolean | null;
};
export type usePermissionQuery$data = {
  readonly projectsRest?: {
    readonly count: number | null;
  } | null;
};
export type usePermissionQuery = {
  response: usePermissionQuery$data;
  variables: usePermissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locator"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "locator",
            "variableName": "locator"
          }
        ],
        "concreteType": "Projects",
        "kind": "LinkedField",
        "name": "projectsRest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "count",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePermissionQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePermissionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "27df31a31f5ebde24536e8736d354890",
    "id": null,
    "metadata": {},
    "name": "usePermissionQuery",
    "operationKind": "query",
    "text": "query usePermissionQuery(\n  $locator: String\n  $skip: Boolean = false\n) {\n  projectsRest(locator: $locator) @skip(if: $skip) {\n    count\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae45d734bd861a6a06b669a75e9ab409";

export default node;
